import React from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Plus, Trash2 } from "lucide-react";
import { UpgradeNote } from "./UpgradeNote";

const TEMPLATES = [
  { slug: "about-us", title: "About Us", content: "Tell customers who you are and why you started your store." },
  { slug: "contact", title: "Contact Us", content: "Phone: \nEmail: \nAddress: \nWorking hours: " },
  { slug: "return-policy", title: "Return Policy", content: "Returns accepted within 7 days of delivery in original condition." },
  { slug: "shipping", title: "Shipping Info", content: "Orders ship within 2 business days. Delivery in 3-7 days." },
];

const slugify = (t) => t.toLowerCase().trim().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export const PagesSection = ({ form, setField, allowed, maxPages }) => {
  const pages = form.pages || [];
  const update = (i, key, val) =>
    setField("pages", pages.map((p, idx) => (idx === i ? { ...p, [key]: val, ...(key === "title" ? { slug: slugify(val) } : {}) } : p)));
  const add = (tpl) => pages.length < maxPages && setField("pages", [...pages, { ...tpl }]);
  const remove = (i) => setField("pages", pages.filter((_, idx) => idx !== i));
  const unused = TEMPLATES.filter((t) => !pages.some((p) => p.slug === t.slug));

  if (!allowed) return <UpgradeNote feature="Store pages (About, Contact, Return Policy)" testId="pages-upgrade-note" />;

  return (
    <div className="space-y-4">
      <p className="text-sm text-gray-500">{pages.length} / {maxPages} pages used. Pages appear in your store's menu and footer.</p>
      {pages.map((p, i) => (
        <div key={i} className="p-4 rounded-xl border border-gray-100 space-y-3" data-testid={`store-page-editor-${i}`}>
          <div className="flex gap-2">
            <Input value={p.title} onChange={(e) => update(i, "title", e.target.value)} placeholder="Page title" data-testid={`store-page-title-${i}`} />
            <Button type="button" variant="outline" size="icon" onClick={() => remove(i)} className="text-red-600" data-testid={`store-page-remove-${i}`}>
              <Trash2 className="w-4 h-4" />
            </Button>
          </div>
          <Textarea value={p.content} onChange={(e) => update(i, "content", e.target.value)} rows={4} data-testid={`store-page-content-${i}`} />
        </div>
      ))}
      {pages.length < maxPages && (
        <div className="flex flex-wrap gap-2">
          {unused.map((t) => (
            <Button key={t.slug} type="button" variant="outline" size="sm" onClick={() => add(t)} data-testid={`add-page-${t.slug}`}>
              <Plus className="w-4 h-4 mr-1" />{t.title}
            </Button>
          ))}
          <Button type="button" variant="outline" size="sm" onClick={() => add({ slug: `page-${Date.now().toString(36)}`, title: "New Page", content: "" })} data-testid="add-page-custom">
            <Plus className="w-4 h-4 mr-1" />Custom Page
          </Button>
        </div>
      )}
    </div>
  );
};
